import moment from 'moment-timezone';
import { Employee } from './Employee';
import { Employer } from './Employer';
import { SalaryRestriction } from './SalaryRestriction';
import { SalaryRestrictionProvider } from './SalaryRestrictionProvider';
import { timezone } from './czechia/MomentTestSupport';
import { PayPeriodInterval } from './PayPeriodInterval';
import { getEndOfPayPeriodInterval } from './utils/getEndOfPayPeriodInterval';

interface Record extends SalaryRestriction {
  validFrom: string;
  validTo?: string;
}

export class InMemorySalaryRestrictionProvider
  implements SalaryRestrictionProvider {
  private records: Record[] = [];

  public add(record: Record): this {
    this.records.push(record);
    return this;
  }

  public addMany(records: Record[]): this {
    for (const record of records) {
      this.add(record);
    }
    return this;
  }

  public async get(
    employeeId: Employee["id"],
    employerId: Employer["id"],
    interval: PayPeriodInterval,
  ): Promise<Record | null> {
    return this.records.find((record) => {
      if (employeeId !== record.employeeId || employerId !== record.employerId) {
        return false;
      }

      const validFrom = moment.tz(record.validFrom, timezone);
      const validTo = record.validTo && moment.tz(record.validTo, timezone);
      const intervalStarts = moment.tz(interval.startsOn, timezone);
      const intervalEnds = getEndOfPayPeriodInterval(interval, timezone);

      if (validTo) {
        return validFrom.isSameOrBefore(intervalEnds) && validTo.isSameOrAfter(intervalStarts);
      }
      return validFrom.isSameOrBefore(intervalEnds);
    }) ?? null;
  }
}
